import dayjs from "dayjs";
import React from "react";
const Columns = ({ filters, fixDate, baseCounter }) => {
  const isOperatorReport = filters.report_type === "operator";

  let columns = [
    {
      name: "#",
      cell: (row, index) => baseCounter + index + 1
    },
    {
      id: "unidad",
      name: "Unidad",
      selector: (row) => row.number,
    },
    {
      id: "operador",
      name: "Operador",
    },
    {
      id: "date",
      name: "Fecha",
      selector: (row) => dayjs(fixDate).format("DD/MM/YYYY"),
    },
    {
      id: "count_day",
      name: "Días",
      selector: (row) => row.salidas_count == 0 ? 0 : 1,
    },
    {
      id: "concesionario",
      name: "Concesionario",
      selector: (row) => row.concessionary?.name,
    },
  ];
  return columns;
};

export default Columns;

//vaneton beicli
